module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('graveyard-select'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('map-marker')], 1)]), _vm._v(" "), _c('custom-table', {
    attrs: {
      "sendCriteria": true,
      "edit": "/areas/{:id}",
      "criteria": _vm.criteria,
      "add": "/areas/new",
      "default-sort": _vm.defSort,
      "search": "",
      "src-model": this.$store.getters.models('areas'),
      "cols": _vm.cols
    },
    on: {
      "criteriaChange": _vm.newCriteria,
      "modelChange": _vm.newAreas,
      "print": _vm.print
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Flächenverwaltung")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f9a49f5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AreaOverview.vue
// module id = 448
// module chunks = 0